import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/solid";
import React, { Dispatch, SetStateAction } from "react";
import { Link } from "gatsby";

const navigation = [
  { ko: "장안", en: "About", href: "/#about" },
  { ko: "도서", en: "Books", href: "#" },
  { ko: "이야기", en: "Stories", href: "/#notice" },
  { ko: "이벤트", en: "Events", href: "#" },
  { ko: "문의", en: "Contact", href: "/#qna" },
];

const Header = ({
  mobileOpen,
  setMobileOpen,
}: {
  mobileOpen: boolean;
  setMobileOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <header className="border-b-[1px] border-stone-400">
      <nav
        className="flex items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5">
            <span className="sr-only">JangAn</span>
            <img
              className="h-8 w-8"
              src="https://bucket.jangan.co/logo-transp.png"
              alt="logo"
            />
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            <Link
              key={item.en}
              to={item.href}
              className="text-sm font-semibold leading-6 text-gray-900"
            >
              {item.ko}
            </Link>
          ))}
        </div>
      </nav>
      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileOpen}
        onClose={setMobileOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-y sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">JangAn</span>
              <img
                className="h-8 w-8"
                src="https://bucket.jangan.co/logo-transp.png"
                alt="logo"
              />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root"></div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
};

export default Header;
